/**
 * HoM Experiments — Layer-based experiment engine
 */
(function () {
    'use strict';

    var STATSIG_TIMEOUT_MS = 3000;
    var assignments = {};

    /* =========================
       Core helpers
    ========================== */
    var core = {
        waitForStatsig: function (callback) {
            var resolved = false;

            function resolve() {
                if (resolved) return;
                resolved = true;
                callback();
            }

            var timer = setTimeout(function () {
                console.warn('[HoMExperiments] Statsig timeout');
                resolve();
            }, STATSIG_TIMEOUT_MS);

            (function check() {
                var statsigExists = typeof statsig !== 'undefined' && typeof statsig.getLayer === 'function';
                var homStatsigReady = window.HoMStatsig && window.HoMStatsig.ready === true;

                if (statsigExists && homStatsigReady) {
                    clearTimeout(timer);
                    resolve();
                } else {
                    setTimeout(check, 50);
                }
            })();
        },

        getParam: function (layer, key, fallback) {
            if (!layer) return fallback;
            var value = layer.get(key, fallback);
            assignments[key] = value;
            return value;
        },

        getProductParam: function (layer, baseKey, productId, fallback) {
            if (!layer || !productId) return fallback;
            var key = baseKey + '_' + productId;
            var value = layer.get(key, fallback);
            assignments[key] = value;
            return value;
        },

        isHtml: function (str) {
            if (!str) return false;
            return /<[a-z][\s\S]*>/i.test(str);
        },

        renderContent: function (element, content) {
            if (!element || !content) return;
            if (this.isHtml(content)) {
                element.innerHTML = content;
            } else {
                element.innerHTML = '';
                var p = document.createElement('p');
                p.textContent = content;
                element.appendChild(p);
            }
        }
    };

    /* =========================
       Membership Collection Layer
    ========================== */
    var membershipLayer = {
        LAYER_NAME: 'membership_page',
        isActive: function () {
            return /^\/collections\/house-of-manifestation-membership\/?$/.test(
                window.location.pathname
            );
        },

        applyHero: function (layer) {
            var headlineText = core.getParam(layer, 'hero_headline', '');
            var descriptionText = core.getParam(layer, 'hero_description', '');
            var instructionText = core.getParam(layer, 'hero_instruction', '');

            var heroContainer = document.querySelector(
                '#MainContent .section.section--page-width'
            );
            if (!heroContainer) return;

            if (headlineText) {
                var h3 = heroContainer.querySelector('h3');
                if (h3 && h3.textContent !== headlineText) {
                    h3.textContent = headlineText;
                }
            }

            var rteBlocks = heroContainer.querySelectorAll('rte-formatter');

            if (descriptionText && rteBlocks[0]) {
                core.renderContent(rteBlocks[0], descriptionText);
            }

            if (instructionText && rteBlocks[1]) {
                rteBlocks[1].innerHTML = '';
                var p2 = document.createElement('p');
                var strong = document.createElement('strong');
                strong.textContent = instructionText;
                p2.appendChild(strong);
                rteBlocks[1].appendChild(p2);
            }
        },

        applyProductCardExperiments: function (layer) {
            document.querySelectorAll('product-card').forEach(function (card) {
                var productId =
                    card.dataset.productId ||
                    card.getAttribute('data-product-id') ||
                    card.getAttribute('product-id');

                if (!productId) return;

                var imageUrl = core.getProductParam(layer, 'product_image', productId, '');
                var saleText = core.getProductParam(layer, 'product_sale_badge', productId, '');
                var compareLabel = core.getProductParam(layer, 'product_compare_label', productId, '');

                if (imageUrl) {
                    var img = card.querySelector('img[src]');
                    if (img && img.src !== imageUrl) {
                        img.src = imageUrl;
                        img.removeAttribute('srcset');
                    }
                }

                if (saleText) {
                    var badge = card.querySelector(
                        '.product-badges--top-right .product-badges__badge'
                    );
                    if (badge && badge.textContent !== saleText) {
                        badge.textContent = saleText;
                    }
                }

                if (compareLabel) {
                    var price = card.querySelector('.compare-at-price');
                    if (price && price.textContent !== compareLabel) {
                        price.textContent = compareLabel;
                    }
                }
            });
        },

        applyAffiliateExperiment: function (layer) {
            var ctaLabel = core.getParam(layer, 'affiliate_cta_label', '');
            var affiliateText = core.getParam(layer, 'affiliate_text', '');

            var link = document.querySelector(
                'a[href="/collections/house-of-manifestation-affiliate"]'
            );
            if (!link) return;

            if (ctaLabel && link.textContent !== ctaLabel) {
                link.textContent = ctaLabel;
            }

            if (affiliateText) {
                var parent = link.parentElement;
                if (!parent) return;

                var rteBlocks = parent.querySelectorAll('rte-formatter');
                var rte = rteBlocks[1];
                if (!rte) return;

                core.renderContent(rte, affiliateText);
            }
        },

        init: function () {
            var layer = statsig.getLayer(this.LAYER_NAME);
            this.applyHero(layer);
            this.applyProductCardExperiments(layer);
            this.applyAffiliateExperiment(layer);
        }
    };

    /* =========================
       Affiliate Collection Layer
    ========================== */
    var affiliateLayer = {
        LAYER_NAME: 'affiliate_page',
        isActive: function () {
            return /^\/collections\/house-of-manifestation-affiliate\/?$/.test(
                window.location.pathname
            );
        },

        applyHero: function (layer) {
            var headlineText = core.getParam(layer, 'hero_headline', '');
            var descriptionText = core.getParam(layer, 'hero_description', '');
            var instructionText = core.getParam(layer, 'hero_instruction', '');

            var heroContainer = document.querySelector(
                '#MainContent .section.section--page-width'
            );
            if (!heroContainer) return;

            if (headlineText) {
                var h3 = heroContainer.querySelector('h4');
                if (h3 && h3.textContent !== headlineText) {
                    h3.textContent = headlineText;
                }
            }

            var rteBlocks = heroContainer.querySelectorAll('rte-formatter');

            if (descriptionText && rteBlocks[0]) {
                core.renderContent(rteBlocks[0], descriptionText);
            }

            if (instructionText && rteBlocks[1]) {
                rteBlocks[1].innerHTML = '';
                var p2 = document.createElement('p');
                var strong = document.createElement('strong');
                strong.textContent = instructionText;
                p2.appendChild(strong);
                rteBlocks[1].appendChild(p2);
            }
        },

        applyProductCardExperiments: function (layer) {
            document.querySelectorAll('product-card').forEach(function (card) {
                var productId =
                    card.dataset.productId ||
                    card.getAttribute('data-product-id') ||
                    card.getAttribute('product-id');

                if (!productId) return;

                var imageUrl = core.getProductParam(layer, 'product_image', productId, '');
                var saleText = core.getProductParam(layer, 'product_sale_badge', productId, '');
                var compareLabel = core.getProductParam(layer, 'product_compare_label', productId, '');

                if (imageUrl) {
                    var img = card.querySelector('img[src]');
                    if (img && img.src !== imageUrl) {
                        img.src = imageUrl;
                        img.removeAttribute('srcset');
                    }
                }

                if (saleText) {
                    var badge = card.querySelector(
                        '.product-badges--top-right .product-badges__badge'
                    );
                    if (badge && badge.textContent !== saleText) {
                        badge.textContent = saleText;
                    }
                }

                if (compareLabel) {
                    var price = card.querySelector('.compare-at-price');
                    if (price && price.textContent !== compareLabel) {
                        price.textContent = compareLabel;
                    }
                }
            });
        },

        init: function () {
            var layer = statsig.getLayer(this.LAYER_NAME);
            this.applyHero(layer);
            this.applyProductCardExperiments(layer);
        }
    };

    /* =========================
       Enrollment Page Layer
    ========================== */
    var enrollmentLayer = {
        LAYER_NAME: 'enrollment_page',
        isActive: function () {
            return /^\/pages\/enrollment-page\/?$/.test(window.location.pathname);
        },

        applyHero: function (layer) {
            var headlineText = core.getParam(layer, 'hero_headline', '');
            var descriptionHtml = core.getParam(layer, 'hero_description', '');

            if (headlineText) {
                var h3 = document.querySelector('h3');
                if (h3 && h3.textContent !== headlineText) {
                    h3.textContent = headlineText;
                }
            }

            if (descriptionHtml) {
                var rte = document.querySelector('rte-formatter');
                if (rte) {
                    core.renderContent(rte, descriptionHtml);
                }
            }
        },

        applyCollectionImages: function (layer) {
            var affiliateImage = core.getParam(layer, 'affiliate_image', '');
            var membershipImage = core.getParam(layer, 'membership_image', '');

            if (affiliateImage) {
                var affiliateLink = document.querySelector('a.collection-card__link[href="/collections/house-of-manifestation-affiliate"]');
                if (affiliateLink) {
                    var affiliateCard = affiliateLink.closest('.collection-card');
                    if (affiliateCard) {
                        var img = affiliateCard.querySelector('.collection-card__inner img');
                        if (img && img.src !== affiliateImage) {
                            img.src = affiliateImage;
                            img.removeAttribute('srcset');
                        }
                    }
                }
            }

            if (membershipImage) {
                var membershipLink = document.querySelector('a.collection-card__link[href="/collections/house-of-manifestation-membership"]');
                if (membershipLink) {
                    var membershipCard = membershipLink.closest('.collection-card');
                    if (membershipCard) {
                        var img = membershipCard.querySelector('.collection-card__inner img');
                        if (img && img.src !== membershipImage) {
                            img.src = membershipImage;
                            img.removeAttribute('srcset');
                        }
                    }
                }
            }
        },

        init: function () {
            var layer = statsig.getLayer(this.LAYER_NAME);
            this.applyHero(layer);
            this.applyCollectionImages(layer);
        }
    };

    /* =========================
       Product Page Layer
    ========================== */
    var productLayer = {
        LAYER_NAME: 'product_page',
        isActive: function () {
            return /^\/products\//.test(window.location.pathname);
        },

        getProductId: function () {
            var form = document.querySelector('product-form-component[data-product-id]');
            return form ? form.getAttribute('data-product-id') : null;
        },

        applyBuyCTA: function (layer) {
            var label = core.getParam(layer, 'buy_cta_label', '');
            var bg = core.getParam(layer, 'buy_cta_background', '');
            var color = core.getParam(layer, 'buy_cta_color', '');

            var btn = document.querySelector(
                'shopify-buy-it-now-button button'
            );
            if (!btn) return;

            if (label && btn.textContent !== label) {
                btn.textContent = label;
            }
            if (bg) btn.style.backgroundColor = bg;
            if (color) btn.style.color = color;
        },

        applyHeading: function (layer, productId) {
            var heading = core.getProductParam(layer, 'product_heading', productId, '');
            if (!heading) return;

            var h1 = document.querySelector('h1');
            if (h1 && h1.textContent !== heading) {
                h1.textContent = heading;
            }
        },

        applyCompareLabel: function (layer, productId) {
            var compareLabel = core.getProductParam(layer, 'product_compare_label', productId, '');
            if (!compareLabel) return;

            var price = document.querySelector('.compare-at-price');
            if (price && price.textContent !== compareLabel) {
                price.textContent = compareLabel;
            }
        },

        applySubscriptionPolicy: function (layer, productId) {
            var policyText = core.getProductParam(layer, 'product_subscription_policy', productId, '');
            if (!policyText) return;

            var el = document.querySelector('.shopify_subscriptions_app_policy');
            if (el && el.textContent !== policyText) {
                el.textContent = policyText;
            }
        },

        applySubscriptionConsent: function (layer, productId) {
            var consentText = core.getProductParam(layer, 'product_subscription_consent', productId, '');
            if (!consentText) return;

            var el = document.querySelector('.shopify-buyer-consent');
            if (el && el.textContent !== consentText) {
                el.textContent = consentText;
            }
        },

        applyDescription: function (layer, productId) {
            var descriptionHtml = core.getProductParam(layer, 'product_description', productId, '');
            if (!descriptionHtml) return;

            var buyBlock = document.querySelector('.buy-buttons-block');
            if (!buyBlock) return;

            var sibling = buyBlock.nextElementSibling;
            while (sibling) {
                if (sibling.tagName && sibling.tagName.toLowerCase() === 'rte-formatter') {
                    sibling.innerHTML = descriptionHtml;
                    return;
                }
                sibling = sibling.nextElementSibling;
            }
        },

        applyImage: function (layer, productId) {
            var imageUrl = core.getProductParam(layer, 'product_image', productId, '');
            if (!imageUrl) return;

            var mediaGrid = document.querySelector('.media-gallery__grid');
            if (!mediaGrid) return;

            mediaGrid.style.pointerEvents = 'none';

            var media = mediaGrid.querySelector('.product-media');
            if (!media) return;

            var img = media.querySelector('img');
            if (img && img.src !== imageUrl) {
                img.src = imageUrl;
                img.removeAttribute('srcset');
            }
        },

        init: function () {
            var layer = statsig.getLayer(this.LAYER_NAME);
            var productId = this.getProductId();

            this.applyBuyCTA(layer);

            if (productId) {
                this.applyHeading(layer, productId);
                this.applyCompareLabel(layer, productId);
                this.applySubscriptionPolicy(layer, productId);
                this.applySubscriptionConsent(layer, productId);
                this.applyDescription(layer, productId);
                this.applyImage(layer, productId);
            }
        }
    };

    /* =========================
       Bootstrap
    ========================== */
    function runExperiments() {
        if (membershipLayer.isActive()) membershipLayer.init();
        if (affiliateLayer.isActive()) affiliateLayer.init();
        if (enrollmentLayer.isActive()) enrollmentLayer.init();
        if (productLayer.isActive()) productLayer.init();
    }

    function hasTargetElements() {
        var hasProductCards = document.querySelectorAll('product-card').length > 0;
        var hasHeroContainer = !!document.querySelector('#MainContent .section.section--page-width');
        var hasProductForm = !!document.querySelector('product-form-component[data-product-id]');
        var hasCollectionCards = document.querySelectorAll('.collection-card').length > 0;

        if (membershipLayer.isActive() || affiliateLayer.isActive()) {
            return hasHeroContainer || hasProductCards;
        }
        if (enrollmentLayer.isActive()) {
            return hasCollectionCards || !!document.querySelector('h3');
        }
        if (productLayer.isActive()) {
            return hasProductForm;
        }
        return true;
    }

    function initWithRetry(maxRetries, delay) {
        var attempts = 0;

        function attempt() {
            attempts++;
            runExperiments();

            if (attempts < maxRetries && !hasTargetElements()) {
                setTimeout(attempt, delay);
            }
        }

        attempt();
    }

    document.addEventListener('DOMContentLoaded', function () {
        core.waitForStatsig(function () {
            initWithRetry(5, 1000);
        });
    });

})();
